import React from 'react';
import styles from './widget.less.js';
import { ErrorBoundary } from '../../utils/error-boundary.js';
import { Transition } from 'react-transition-group';

function wrapWithTransiton(children, props) {
    const { visibilityTransition: animationStyle } = props;
    return (React.createElement(Transition, { in: !!props.visible, timeout: animationStyle.duration }, (state) => {
        const originalStyle = children.props.style || {};
        const style = Object.assign(Object.assign({}, originalStyle), animationStyle[state]);
        return (React.cloneElement(children, Object.assign(Object.assign({}, children.props), { style })));
    }));
}
class Widget extends React.PureComponent {
    render() {
        const { children, style = {}, visibilityTransition, visible, } = this.props;
        const widgetStyle = Object.assign({}, style);
        if (!visibilityTransition) {
            widgetStyle.display = (visible === undefined || visible) ? 'block' : 'none';
        }
        const widget = React.createElement("div", { className: styles.widget, style: widgetStyle },
            React.createElement(ErrorBoundary, null, React.cloneElement(children, children.props)));
        if (visibilityTransition) {
            return wrapWithTransiton(widget, this.props);
        }
        return widget;
    }
}

export { Widget };
//# sourceMappingURL=widget.js.map
